import * as React from 'react';

import {
  ComparisonDelta,
  formatComparisonTextForCard,
  EffectiveDefinition,
  MetricsNeutralColor,
  ThresholdStatus,
} from '@tableau/metrics-engine';

import { SvgIconProps } from '../resources/SvgIcon';
import { getIconForLabel } from '../utils';

export interface CardDeltaLabelProps {
  readonly definition: EffectiveDefinition;
  readonly color?: string;
  readonly comparisonDelta?: ComparisonDelta;
  readonly formatString?: string;
  readonly status?: ThresholdStatus;
}

const ZERO_WIDTH_SPACE = '\u200B';

export const CardDeltaLabel = (props: CardDeltaLabelProps): JSX.Element | null => {
  const delta = props.comparisonDelta;

  if (delta === undefined) {
    return <div style={comparisonStyle}>{ZERO_WIDTH_SPACE}</div>;
  }

  const comparisonText = formatComparisonTextForCard(delta, props.definition, props.formatString, props.status);

  const iconProps: Omit<SvgIconProps, 'name'> = {
    altText: '',
    testId: 'metric-card-delta-label',
    color: props.color ?? MetricsNeutralColor,
    style: { verticalAlign: 'text-top', marginRight: '4px', marginTop: '1px' },
    size: 14,
  };

  const symbol = getIconForLabel(iconProps, props.status ?? ThresholdStatus.UNKNOWN, props.definition, delta);

  return (
    <div
      data-tb-test-id={'metric-comparison-text'}
      style={{ ...comparisonStyle, color: props.color ?? MetricsNeutralColor }}
      role={'img'}
      aria-label={comparisonText.accessibilityText}
    >
      {symbol}
      {comparisonText.text}
    </div>
  );
};

const comparisonStyle: React.CSSProperties = {
  fontSize: '14px',
  fontWeight: 'normal',
};
